import React from 'react'
import PdfCards from './PdfCards'

const PdfReportContent = ({ ...props }) => {

    const generatePdfCards = () => {
        // const data = [ ...props.datum,...props.datum,...props.datum,...props.datum,...props.datum,...props.datum,...props.datum,...props.datum,...props.datum,] //for test
        const data = props.datum
        const columns = props.columns
      
        // Define filter column IDs based on the report type
        const filterColumnIds = {
          'Course Report'       : ['course'],
          'Enrolled Users'      : ['name', 'email'],
          'Lessons Report'      : ['lessonName'],
          'Topics Report'       : ['topicName'],
          'Assignments Report'  : ['assignmentName'],
          'User Report'         : ['name', 'email'],
          'Enrolled Courses'    : ['course'],
        }
      
        // Get filter column IDs for the current report type
        const filterColumnId = filterColumnIds[props.from] || []
      
        // Filter out the columns based on the filter column IDs
        const filteredColumns = columns.filter(column => !filterColumnId.includes(column.id))
      
        // Map the data to include only the filtered columns
        const filteredData = data.map(row =>
          filteredColumns.reduce((acc, column) => {
            if (row.hasOwnProperty(column.id)) {
              acc[column.id] = row[column.id]
            }
            return acc
          }, {})
        )
      
        // Return the PdfCards component with the filtered data and columns
        return (
            <PdfCards
                filteredData={filteredData}
                filteredColumns={filteredColumns}
                rawData={data}
                from={props.from}
                />
        )
    }

    return generatePdfCards()
}

export default PdfReportContent